import { isNative, isIos } from 'src/utils/platform';
import TestFlightPlugin from '../../plugins/TestFlightPlugin';

export const isTestFlight = async () => {
  if (!isNative() || !isIos()) {
    return false;
  }

  try {
    const { value: isTestFlight } =
      await TestFlightPlugin.isSimulatorOrTestFlight({ value: '' });
    return isTestFlight;
  } catch {
    return false;
  }
};
